<div class="rsm-dialog">
  <h2 class="rsm-dialog__title">{{ schluessel + '.title' | translate }}</h2>
  <p class="rsm-dialog__body">
    {{ schluessel + '.body' | translate: { name: data.oldValue, count: data.count } }}
  </p>

  <label class="rsm-dialog__label" for="rsm-target">
    {{ schluessel + '.targetLabel' | translate }}
  </label>
  <select
    id="rsm-target"
    class="rsm-dialog__select"
    [value]="selectedTarget()"
    (change)="onTargetChange($any($event.target).value)"
  >
    @for (t of data.targets; track t) {
      <option [value]="t">{{ t }}</option>
    }
  </select>

  <div class="rsm-dialog__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ schluessel + '.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!selectedTarget()" (click)="confirm()">
      {{ schluessel + '.confirm' | translate }}
    </button>
  </div>
</div>
